<template>
  <v-container fluid>
    <v-card max-width="900px" min-height="192px" max-height="195px" rounded="t-lg b-0" color="rgb(160 180 183)" class="mx-auto">
      <v-dialog max-width="600px" v-model="dialog" persistent>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" v-bind="attrs" v-on="on" elevation="1" absolute right top @click="toggleModal = !toggleModal"
            ><v-icon small left>mdi-pencil</v-icon> Change Password</v-btn
          >
          <v-btn absolute v-else right top fab small elevation="1"> <v-icon>mdi-pencil</v-icon></v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">Change Password</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <form @submit.prevent="updatePassword">
                  <v-row>
                    <v-col cols="12">
                      <v-text-field type="password" v-model="password" placeholder="*******" label="New Password" required></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field type="password" v-model="confirmPassword" placeholder="*******" label="Confirm Password" required></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <div class="d-flex justify-end align-end">
                        <v-btn type="submit" color="primary" elevation="1">
                          Update
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="dialog = false">
                          Close
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </form>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card>
    <v-card max-width="900px" class="v-card-profile mx-auto" rounded="t-0 b-lg">
      <v-row>
        <v-col cols="12" md="7">
          <v-card-text>
            <v-avatar style="position:absolute; left:30px; top:-120px; border:5px solid #fff;" class="profile" size="164">
              <v-img src="/data-sources/avatars/default-user.png"></v-img>
            </v-avatar>
            <v-card-title class="mt-4 mb-2 headline">{{ fullName }}</v-card-title>
            <v-simple-table>
              <tbody>
                <tr v-if="year">
                  <td class="font-weight-bold body-2 subtitle">
                    Enrollment Year:
                  </td>
                  <td>
                    {{ year || '' }}
                  </td>
                </tr>
                <tr v-if="type">
                  <td class="font-weight-bold body-2 subtitle">
                    {{ studentClass ? 'Gender:' : 'Center Type:' }}
                  </td>
                  <td v-if="studentClass && type === 'MALE' || studentClass && type === 'Male'">
                   Boy
                  </td>
                  <td v-if="studentClass && type === 'FEMALE' || studentClass && type === 'Female'">
                   Girl
                  </td>
                  <td v-if="!studentClass">
                   {{type}}
                  </td>
                   <!-- <td>
                   {{ studentClass && type === "MALE" ? 'Boy' : 'Girl' }}
                  </td> -->
                </tr>
                <tr v-if="enrollementCode">
                  <td class="font-weight-bold body-2 subtitle">
                    Enrollment Code:
                  </td>
                  <td>
                    {{ enrollementCode || '' }}
                  </td>
                </tr>
                <tr v-if="fatherName">
                  <td class="font-weight-bold body-2 subtitle">
                    Parent Name:
                  </td>
                  <td>
                    {{ fatherName || '' }}
                  </td>
                </tr>
                <tr v-if="studentClass">
                  <td class="font-weight-bold body-2 subtitle">
                    Student Class:
                  </td>
                  <td>
                    {{ studentClass || '' }}
                  </td>
                </tr>
                <tr v-if="studentSection">
                  <td class="font-weight-bold body-2 subtitle">
                    Student Section:
                  </td>
                  <td>
                    {{ studentSection || '' }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
            <!-- <v-card-subtitle class="body-2 pt-0 " v-show="enrollementCode"><b>Enrollment Code: </b>{{ enrollementCode || '' }}</v-card-subtitle> -->
            <!-- <v-card-subtitle class="body-2 pt-0 " v-if="fatherName"><b>Father Name: </b>{{ fatherName || '' }}</v-card-subtitle>
            <v-card-subtitle class="body-2 pt-0 " v-if="studentClass"><b>Student Class: </b>{{ studentClass || '' }}</v-card-subtitle>
            <v-card-subtitle class="body-2 pt-0 " v-if="studentSection"><b>Student Section: </b>{{ studentSection || '' }}</v-card-subtitle> -->
          </v-card-text>
        </v-col>
        <v-col cols="12" md="5">
          <v-card-text>
            <v-card-subtitle class="body-1 pb-2"
              ><v-icon left>mdi-phone</v-icon><span>{{ mobileNumber }}</span></v-card-subtitle
            >
            <v-card-subtitle class="body-2 pt-0 pb-2"
              ><v-icon left>mdi-email</v-icon><span>{{ emailAddress }}</span></v-card-subtitle
            >
            <v-card-subtitle class="body-2 pt-0" v-show="address"
              ><v-icon left>mdi-home-map-marker</v-icon><span>{{ address || '' }}</span></v-card-subtitle
            >
            <v-card-subtitle class="body-1 pt-0 pb-0 mt-4" v-if="franchisee">
              <v-icon left>mdi-school</v-icon>
              School:
            </v-card-subtitle>
            <span class="ml-4 mb-0" v-show="franchisee" v-for="fr in franchisee" :key="fr.id">
              <v-chip small dark color="accent lighten-3" class=" text-capitalize mt-2">{{ fr.companyName }}</v-chip>
            </span>
            <v-card-subtitle class="body-1 pt-0 pb-0 mt-4">
              <v-icon left>mdi-account-settings</v-icon>
              Access:</v-card-subtitle>
            <span v-show="userRoles" class="ml-4 mb-0" v-for="role in userRoles" :key="role.id">
              <v-chip small dark color="darkblue lighten-3" class=" text-uppercase mt-2">{{ role }}</v-chip>
            </span>
          </v-card-text>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import stores from '@/stores'
import constants from '@/utils/constants'
import _ from 'lodash'
// import MaterialCard from '@/components/template/MaterialCard'

export default {
  name: 'Profile',
  // components: {
  //   MaterialCard
  // },
  data () {
    return {
      role: '',
      fullName: '',
      emailAddress: '',
      dialog: false,
      isLoading: false,
      isStudent: false,
      toggleModal: false,
      password: '',
      confirmPassword: '',
      address: '',
      year: '',
      enrollementCode: '',
      type: '',
      mobileNumber: '',
      franchisee: [],
      fatherName: '',
      studentSection: '',
      studentClass: '',
      userRoles: []
    }
  },
  computed: {
    titleStack () {
      return ['Admin', 'Profile']
    },
    ...mapState(['userName', 'userEmail'])
  },
  created () {
    let storeUser = stores.user
    this.fullName = `${storeUser.userInfo.firstName ? storeUser.userInfo.firstName : ''} ${storeUser.userInfo.lastName ? storeUser.userInfo.lastName : ''}`
    this.franchisee = storeUser.userInfo.franchisee.length > 0 ? storeUser.userInfo.franchisee : ''
    console.log(this.franchisee)
    this.type = storeUser.userInfo && storeUser.userInfo.concept ? storeUser.userInfo.concept : 'Not Available'
    this.year = storeUser.academicYear.academicYear
    if (storeUser.userInfo.userStudentMap && storeUser.userInfo.userStudentMap.studentAdmission) {
      this.class = storeUser.userInfo.userStudentMap.studentAdmission.class
      this.section = storeUser.userInfo.userStudentMap.studentAdmission.section
      this.enrollementCode = storeUser.userInfo.userStudentMap.studentAdmission.studentEnrollment.enrollmentCode
      this.address =
        storeUser.userInfo.userStudentMap.studentAdmission.studentEnrollment.address +
        ' ' +
        storeUser.userInfo.userStudentMap.studentAdmission.studentEnrollment.city +
        ' ' +
        storeUser.userInfo.userStudentMap.studentAdmission.studentEnrollment.state +
        ' ' +
        storeUser.userInfo.userStudentMap.studentAdmission.studentEnrollment.countryName +
        ' ' +
        storeUser.userInfo.userStudentMap.studentAdmission.studentEnrollment.pincode
      this.studentClass = storeUser.userInfo.userStudentMap.studentAdmission.class
      this.studentSection = storeUser.userInfo.userStudentMap.studentAdmission.section
      this.emailAddress = storeUser.userInfo.userStudentMap.studentAdmission.studentEnrollment.fatherEmailID
      this.mobileNumber = storeUser.userInfo.userStudentMap.studentAdmission.studentEnrollment.fatherMobile
      this.fatherName = storeUser.userInfo.userStudentMap.studentAdmission.studentEnrollment.fatherName
    } else {
      this.emailAddress = storeUser.userInfo ? storeUser.userInfo.email : ''
      this.mobileNumber = storeUser.userInfo && storeUser.userInfo.mobile ? storeUser.userInfo.mobile : 'Not Available'
    }
    console.log(storeUser, 'storeUser')
    if (storeUser.ACL.superAdmin) {
      this.userRoles.push('Super Admin')
    } else {
      this.userRoles = _.map(storeUser.roles, 'description')
    }
  },
  methods: {
    async updatePassword () {
      try {
        if (this.password !== this.confirmPassword) {
          this.dialog = false
          return this.$buefy.dialog.alert({
            message: 'The password does not match.',
            type: 'is-danger',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        await http.post(`${constants.API_URL}/api/auth/local/admin/change-password`, {
          confirmPassword: this.confirmPassword,
          password: this.password
        })
        this.dialog = false
        this.toggleModal = false
        this.password = ''
        this.confirmPassword = ''
        return this.$buefy.dialog.alert({
          message: 'Your password has been changed',
          type: 'is-success',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        const { data } = e.response
        this.dialog = false
        return this.$buefy.dialog.alert({
          message: data.message,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    }
  }
}
</script>
